import React from "react";
import { Link, useNavigate } from "react-router-dom";

const DEFAULT_LOGO_URL = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><rect width='200' height='200' rx='100' fill='%23e53935'/><text x='50%25' y='44%25' dominant-baseline='middle' text-anchor='middle' fill='white' font-size='26' font-family='Arial, sans-serif' font-weight='700'>Metho</text><text x='50%25' y='62%25' dominant-baseline='middle' text-anchor='middle' fill='white' font-size='17' font-family='Arial, sans-serif' font-weight='700'>STORE</text></svg>";
const LOGO_LOGISTICS_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_metho-aay-upay/artifacts/o5mnsf6a_metho-logistics.png";
const LOGO_TAP_COUNT_KEY = "metho_logo_tap_count";
const LOGO_TAP_TS_KEY = "metho_logo_tap_ts";

export const Logo = ({ className = "", showTagline = false, variant = "store", size = "md" }) => {
  const nav = useNavigate();
  const src = variant === "logistics" ? LOGO_LOGISTICS_URL : DEFAULT_LOGO_URL;
  const dim = size === "lg" ? "w-14 h-14" : size === "sm" ? "w-8 h-8" : "w-11 h-11";
  const brandName = "METHO AAY-UPAY";
  const parts = String(brandName || "").trim().split(/\s+/).filter(Boolean);
  const primary = parts[0] || "METHO";
  const secondary = parts.slice(1).join(" ") || "AAY-UPAY";

  const onLogoClick = (e) => {
    const now = Date.now();
    let count = Number(localStorage.getItem(LOGO_TAP_COUNT_KEY) || 0);
    let ts = Number(localStorage.getItem(LOGO_TAP_TS_KEY) || 0);
    if (now - ts > 2200) count = 0;
    count += 1;
    localStorage.setItem(LOGO_TAP_COUNT_KEY, String(count));
    localStorage.setItem(LOGO_TAP_TS_KEY, String(now));
    if (count >= 5) {
      localStorage.removeItem(LOGO_TAP_COUNT_KEY);
      localStorage.removeItem(LOGO_TAP_TS_KEY);
      e.preventDefault();
      nav("/admin-login");
      return;
    }

    // On mobile web, single-tap logo can open native install prompt when available.
    const promptEvent = window.__methoInstallPrompt;
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (!isStandalone && promptEvent && typeof promptEvent.prompt === "function") {
      e.preventDefault();
      promptEvent.prompt();
      promptEvent.userChoice
        .then(({ outcome }) => {
          if (outcome === "accepted") {
            localStorage.setItem("install-prompt-dismissed", "1");
          }
        })
        .finally(() => {
          window.__methoInstallPrompt = null;
        });
    }
  };

  return (
    <Link to="/" onClick={onLogoClick} className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt={brandName}
        className={`${dim} rounded-full bg-red-600 object-cover shadow-md ring-2 ring-white`}
        style={{ filter: "hue-rotate(155deg) saturate(2.2) brightness(0.95)" }}
      />
      <div className="flex flex-col leading-none">
        <span className="font-display font-black text-base tracking-tight text-emerald-950">{primary}</span>
        <span className="font-display font-semibold text-[10px] tracking-[0.2em] text-emerald-800 uppercase">{secondary}</span>
        {showTagline && (
          <span className="font-body text-[9px] text-muted-foreground mt-0.5">METHO Logistics · India</span>
        )}
      </div>
    </Link>
  );
};

export default Logo;

